var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page404"}},[_c('h1',[_vm._v("404")]),_c('br'),_c('h4',[_vm._v("Cette page n'existe pas ou a été supprimée")]),_c('br'),_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("Retourner à la page d'accueil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }